import { observer } from 'mobx-react-lite';

import type { Category } from '~/stores/CategoriesStore';

interface Props {
  category: Category;
}

/**
 * Platform figures of the DubaiExpress home: a bordered card with one figure
 * per child category of the CMS block, the child's name as the value and its
 * preview text as the caption. Columns of at least 130px share the width,
 * which gives one row on desktop and two columns on mobile.
 */
const StatsCardDEView = ({ category }: Props) => {
  const items = category.subcategory;

  if (items.length === 0) {
    return null;
  }

  return (
    <section className="mt-7 grid grid-cols-[repeat(auto-fit,minmax(130px,1fr))] gap-x-3 gap-y-3.5 rounded-[10px] border border-[#EDEDED] border-solid px-5 py-4">
      {items.map((item) => (
        <div key={item.id} className="min-w-0">
          <div className="font-bold text-[#141415] text-[20px] leading-[26px] tracking-[-0.02em]">
            {item.name}
          </div>
          <div className="mt-0.5 text-[#8A8A8A] text-[12px] leading-4">
            {item.previewText}
          </div>
        </div>
      ))}
    </section>
  );
};

export const StatsCardDE = observer(StatsCardDEView);
